import { render, staticRenderFns } from "./ModalDept.vue?vue&type=template&id=576b35eb&scoped=true&"
import script from "./ModalDept.vue?vue&type=script&lang=js&"
export * from "./ModalDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576b35eb",
  null
  
)

export default component.exports